import {
  Card,
  CardContent,
  CardHeader,
  CardTitle,
} from "@web/components/ui/card";
import type { CategoryStat } from "@repo/share-log-interfaces";
import { groupSmallItems, buildDetailList } from "../chart-styles";
import { PieWithDetailList } from "./pie-with-detail-list";

interface CategoryChartProps {
  data: CategoryStat[];
}

const COLORS = [
  "var(--chart-1)",
  "var(--chart-2)",
  "var(--chart-3)",
  "var(--chart-4)",
  "var(--chart-5)",
  "var(--chart-grouped)",
];

export function CategoryChart({ data }: CategoryChartProps) {
  const allItems = data
    .filter((d) => d.expense > 0)
    .map((d) => ({ name: d.categoryName, value: d.expense }));

  if (allItems.length === 0) {
    return (
      <Card>
        <CardHeader>
          <CardTitle>카테고리별 지출</CardTitle>
        </CardHeader>
        <CardContent>
          <div className="h-75 flex items-center justify-center text-muted-foreground">
            데이터가 없습니다.
          </div>
        </CardContent>
      </Card>
    );
  }

  const pieData = groupSmallItems(allItems);
  const detailItems = buildDetailList(allItems, COLORS);

  return (
    <Card>
      <CardHeader>
        <CardTitle>카테고리별 지출</CardTitle>
      </CardHeader>
      <CardContent>
        <PieWithDetailList
          pieData={pieData}
          detailItems={detailItems}
          colors={COLORS}
        />
      </CardContent>
    </Card>
  );
}
